<template>
    <div class="ls-box">
        <el-button type="danger" @click="e=>{_type(e,1)}">复检报验单</el-button>
        <el-button type="warning" @click="e=>{_type(e,2)}">钢材出厂合格证，试验报告核查要录</el-button>
        <el-dialog :title="show_title" :visible.sync="show_info" width="500px" @close="_reset('r')" append-to-body>
            <el-form>
                <el-form-item label="进场日期：">
                    <ls-date v-model="r.date_in"></ls-date>
                </el-form-item>
                <el-form-item label="报验地区：">
                    <el-radio-group v-model="r.area">
                        <el-radio-button :label="1">
                            武汉
                        </el-radio-button>
                        <el-radio-button :label="2">
                            湖北
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="单位工程：">
                    <el-input v-model="r.dwgc"></el-input>
                    <p class="tips">内容务必于台账单位工程一致</p>
                </el-form-item>
                <el-form-item label="分部工程：">
                    <el-input v-model="r.fb"></el-input>
                    <p class="tips">内容务必于台账单位一致</p>
                </el-form-item>
                <el-form-item label="打印份数：">
                    <el-input v-model="r.num"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_submit">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props: {
            table: {},
        },
        data() {
            return {
                show_info: false,
                r: {},
                show_title: ''
            }
        },
        created() {
        },
        methods: {
            _pdf_type(e, type) {

                this.show_title = e.target.innerText;
                this.r.type = type;
                this.show_info = true;
            },
            _submit() { }
        }
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>